<template>
    <div>
         <action-row>
            <my-btn type="new" @click="addHandler()"></my-btn>
         </action-row>
        <my-table :data="tableData">
            <el-table-column label="专家姓名" prop="zjname"></el-table-column>
            <!-- <el-table-column label="成员编号" prop="pwhcycode"></el-table-column> -->
            <el-table-column label="身份证号" prop="e_zjsfzh"></el-table-column>
            <el-table-column label="工作单位" prop="e_gzdw"></el-table-column>
            <el-table-column label="手机" prop="e_zjsj"></el-table-column>
            <el-table-column label="专家身份">
                <template slot-scope="scope">
                    {{scope.row.zjsf === '1' ? '业主代表' : (scope.row.zjsf === '0' ? '评标专家' : '-')}}
                </template>
            </el-table-column>
            <el-table-column label="职称" prop="e_zjzc"></el-table-column>
            <el-table-column label="专家登录密码" prop="guestpasscode"></el-table-column> 
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <template v-if="end === '1'">
                        <el-button type="text" @click="pingjiaHandler(scope.row)">专家评价</el-button> 
                    </template>
                    <template v-else>
                        <my-btn
                            type="edit"
                            @click="editHandler(scope.row)">
                            修改
                        </my-btn>
                    </template>
                </template>
            </el-table-column>
        </my-table>

        <my-pagination
            ref="page"
            v-model="tableData"
            :search="pgData"
            :action="`${getGetters('bidUrl')}/newpingbiao/pbwyh/getcy.json`">
        </my-pagination>

        <my-dialog v-model="dialogVisible" width="1200px">
            <component
                v-if="dialogVisible"
                :is="dialogComponent"
                :data="dialogData"
                @cancle="dialogClose"
            ></component>
        </my-dialog>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
import DIALOG_LIST_PAGE_MIXIN from '@views/mixins/dialog-list-page'


export default {
    mixins: [ FORM_PAGE_MIXIN, LIST_PAGE_MIXIN, DIALOG_LIST_PAGE_MIXIN ],
    components: {
        FormPingJia: () => import('./form-ping-jia/index'),
        FormChengYuan: () => import('./form-cheng-yuan'),
    },
    data() {
        return {
            pgData: {
                procode: this.getQuery('procode'),
                zjsqcode: this.getQuery('zjsqcode'),
                sortname: 'a.addtime'
            },

            end: '',
            isnzk:'',
            dialogComponent: '',
            dialogData: {}
        }
    },
    computed: {
        query() {
            return this.getQuery()
        }
    },
    methods: {
        pingjiaHandler(row) {
            this.dialogData = {
                pwhcycode: row.pwhcycode
            };
            this.dialogComponent = 'form-ping-jia';
            this.dialogShow();
        },
  
        editHandler(row) {
            if(this.isnzk===false) {
                this.dialogData = {
                    id: row.pwhcycode,
                    procode:this.getQuery('procode'),
                    zjsqcode:this.getQuery('zjsqcode'),
                    zgys:this.getQuery('zgys'),
                };
            }
            if(this.isnzk===true) {
                this.dialogData = {
                    id: row.pwhcycode,
                    procode:this.getQuery('procode'),
                    zjsqcode:this.getQuery('zjsqcode'),
                };
            }
            this.dialogComponent = 'form-cheng-yuan';
            this.dialogShow();
        },
        addHandler(){
            if(this.isnzk===false) {
                this.dialogData = {
                    procode:this.getQuery('procode'),
                    zjsqcode:this.getQuery('zjsqcode'),
                    zgys:this.getQuery('zgys'),
                };
            }
            if(this.isnzk===true) {
                this.dialogData = {
                    procode:this.getQuery('procode'),
                    zjsqcode:this.getQuery('zjsqcode'),
                    // zgys:this.getQuery('zgys'),
                };
            }
            this.dialogComponent = 'form-cheng-yuan';
            this.dialogShow();
        }
    },     
    created() {
        this.jspInit(`${this.getGetters('bidUrl')}/newpingbiao/pbwyh/cygl.json`, 
        {
           procode:this.getQuery('procode'),
           zjsqcode:this.getQuery('zjsqcode'),
           zgys:this.getQuery('zgys'),
        }
        , data => {
           
            this.isnzk=data.isnzk
            this.jspDataInit(data, ['end']);
        });
    }
}
</script>

<style scoped lang="scss">

</style>
